"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var filter_type_1 = require("./filter-type");
/**
 * Helper to determine whether {@link FilterType} has negative meaning.
 */
var FilterTypeNegations = /** @class */ (function () {
    function FilterTypeNegations() {
    }
    /**
     * Determines whether specified filtering method has negative meaning.
     * @param {!FilterType} filterType - The filtering method.
     * @returns {boolean} True if filtering method is negating, false otherwise.
     */
    FilterTypeNegations.isNegating = function (filterType) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filterType);
        return FilterTypeNegations.NEGATING_FILTER_TYPES.indexOf(filterType) !== -1;
    };
    /**
     * All the {@link FilterType}s with negative meaning.
     * @type {FilterType[]}
     */
    FilterTypeNegations.NEGATING_FILTER_TYPES = [
        filter_type_1.FilterType.NOT_AMONG,
        filter_type_1.FilterType.NOT_CONTAINS,
        filter_type_1.FilterType.NOT_EQUALS,
        filter_type_1.FilterType.NOT_BETWEEN,
        filter_type_1.FilterType.NOT_CURRENT,
        filter_type_1.FilterType.IS_NOT,
        filter_type_1.FilterType.SPECIFIED
    ];
    return FilterTypeNegations;
}());
exports.FilterTypeNegations = FilterTypeNegations;
//# sourceMappingURL=filter-type-negations.js.map